import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { DynamicBG } from "~/components/blocks";
import {
  Title,
  Text,
  Margin,
  Loading,
  Button,
  ErrorMessage,
} from "~/components/elements";
import * as S from "./styles";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";
import { scrollTop, parentScrollTop } from "~/utils/tools";

export default function VerifiedEmail() {
  const mobile = isMobile();
  const dispatch = useDispatch();

  const Code = window.location.pathname.split("/")[2];

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const sending = useSelector((state) => state?.signUp?.validate?.sending);
  const errorMessage = useSelector((state) => state?.signUp?.validate?.message);
  const success = useSelector((state) => state?.signUp?.validate?.success);

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };
  useEffect(() => {
    scrollTop();
    parentScrollTop();
    if (Code) {
      dispatch(
        SignUpActions.sendConfirmCode({
          Code: Code,
          confirm_email: true,
          url: url,
          origin: origin
        })
      );
    }
    return () => {
      dispatch(SignUpActions.setConfirmData());
    };
  }, [dispatch, Code, url, origin]);
  return (
    <motion.div
      variants={animations}
      className="single"
      initial="exit"
      animate="enter"
      exit="exit"
    >
      <DynamicBG content={true}>
        {sending ? (
          <Margin mt={mobile ? 6 : 12} mb={mobile ? 8 : 12}>
            <Loading />
          </Margin>
        ) : (
          <S.ContentHolder success={success}>
            <Margin mt={mobile ? 6 : 12} mb={mobile ? 1 : 2}>
              {success && (
                <Title as="2" level="4" levelDesktop="3">
                  Correo electrónico verificado
                </Title>
              )}
              {!success && errorMessage && (
                <Title as="2" level="4" levelDesktop="3">
                  Lo siento. No pudimos realizar esa acción.
                </Title>
              )}
            </Margin>
            <Margin mb={4}>
              {success ? (
                <Text level="1">
                  Gracias por la confirmación.<br />
                  {/* Ahora podemos proceder con tu acceso. */}
                </Text>
              ) : (
                <ErrorMessage inset>{errorMessage}</ErrorMessage>
              )}
            </Margin>
            <Margin mb={mobile ? 8 : 12}>
              <Button
                onClick={() => history.push("/login")}
                color="primary"
                id="loginButtonVerify"
              >
                ACCEDER A LA CUENTA
              </Button>
            </Margin>
          </S.ContentHolder>
        )}
      </DynamicBG>
    </motion.div>
  );
}
